module.exports = __webpack_public_path__ + "img/blog-51.683a12fa.jpg";